import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

export interface gridTile {
    align_h: string;
    align_v: string;
    border_t: boolean;
    border_r: boolean;
    border_b: boolean;
    border_l: boolean;
    color?: string;
    content: { name: string, tag: string }[];
    size: string;
}

@Component({
    selector: "section-custom-label-renderer",
    templateUrl: "label-renderer.component.html",
    styleUrls: ["label-renderer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,

})

export class CustomLabelRenderComponent implements OnChanges {

    @Input()
    public width: number;

    @Input()
    public height: number;

    @Input()
    public layout: gridTile[];

    @Input()
    public data: any;

    public constructor(
        private sanitizer: DomSanitizer,
        private changeDetectorRef: ChangeDetectorRef,
    ) {

    }

    public trustHtml(html: string): SafeHtml {
        if (html && html.trim()) {
            return this.sanitizer.bypassSecurityTrustHtml(html);
        }
        return "";
    }

    public setHorizontalAlign(align: string): string {
        switch (align) {
            case "left":
                return "flex-start";
            case "right":
                return "flex-end";
            case "stretch":
                return "stretch";
            default:
                return "center";
        }
    }

    public setVerticalAlign(align: string): string {
        switch (align) {
            case "bottom":
                return "flex-end";
            case "middle":
                return "center";
            case "top":
            default:
                return "flex-start";
        }
    }


    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.data) {
            this.data = changes.data.currentValue;
        }

        if (changes.layout) {
            this.layout = changes.layout.currentValue;
        }

        if (changes.width) {
            this.width = changes.width.currentValue;
        }

        if (changes.height) {
            this.height = changes.height.currentValue;
        }

        this.changeDetectorRef.markForCheck();
    }

}